import {
  GET_INTERNAL_JOB_LIST_SEARCH_UPDATE,
  GET_INTERNAL_JOB_LIST_SELECT_JOB_UPDATE,
  GET_INTERNAL_JOB_LIST_SUCCESS,
  GET_INTERNAL_SURVEY_LIST,
  GET_INTERNAL_SURVEY_LIST_ERROR,
  GET_INTERNAL_SURVEY_LIST_SUCCESS,
  RESET_INTERNAL_JOBS_REDUCER
} from '../actions/InternalJobsActions';
import { combineReducers } from 'redux';
import { getIndexOfElement, getInternalAvgData } from '../../../CompensationSummary/payElementMappings';
import { PRICING_TYPE } from '../../../SkillGeoDifferential/SkillGeoDifferentialReducer';
import InternalJobsGridReducer from '../InternalJobsGrid/InternalJobsGridCreate';
// WIP: Need to add error states for errored API requests

const initialState = {
  internalJobList: [],
  surveysLoading: false,
  offset: 0,
  limit: 50,
  typedSearchQuery: '',
  searchQuery: '',
  selectedJob: null,
  searchResultsCount: 0
};

const InternalJobsReducer = function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_INTERNAL_JOB_LIST_SUCCESS: {
      return {
        ...state,
        internalJobList: action.payload.data,
        offset: action.payload.offset,
        limit: action.payload.limit,
        searchQuery: action.payload.searchQuery,
        selectedJob: state.selectedJob || action.payload.data[0],
        searchResultsCount: action.payload.searchResultsCount
      };
    }
    case GET_INTERNAL_SURVEY_LIST: {
      return {
        ...state,
        surveysLoading: true
      };
    }
    case GET_INTERNAL_SURVEY_LIST_ERROR: {
      return {
        ...state,
        surveysLoading: false,
        selectedJob: action.selectedJob || state.selectedJob
      };
    }
    case GET_INTERNAL_JOB_LIST_SEARCH_UPDATE: {
      return {
        ...state,
        typedSearchQuery: action.data
      };
    }
    case GET_INTERNAL_JOB_LIST_SELECT_JOB_UPDATE: {
      return {
        ...state,
        selectedJob: action.job
      };
    }
    case GET_INTERNAL_SURVEY_LIST_SUCCESS: {
      return {
        ...state,
        surveysLoading: false,
        selectedJob: action.selectedJob
      };
    }
    case RESET_INTERNAL_JOBS_REDUCER: {
      return {
        ...initialState
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
};

export default combineReducers({
  InternalJobsMainReducer: InternalJobsReducer,
  InternalJobsGridReducer
});
